import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { selectUserInformations } from '../../features/authSlice';
import axios from 'axios';
import { API } from '../../shared/api/Api';
import { showToast } from '../../utils/utils';
import CategoryTable from '../../components/Tables/CategoryTable';


const DEBOUNCE_DELAY = 700;

const CategoryPage = () => {
    const [categories, setCategories] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [search, setSearch] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const [loader, setLoader] = useState(true);
    const [reFetchData, setReFetchData] = useState(false);
    const [orderBy, setOrderBy] = useState("created_at"); // Default sorting column
    const [orderDir, setOrderDir] = useState("DESC"); // Default sorting direction

    const user = useSelector(selectUserInformations);

    const fetchCategories = useCallback(async () => {
        setLoader(true);
        try {
            const { data } = await axios.get(API.Categories.app_categories_all, {
                params: { 
                    page: currentPage, 
                    search: debouncedSearch,
                    orderBy: orderBy,
                    orderDir: orderDir
                },
                headers: {
                    Authorization: `Bearer ${user.token}`
                }
            })

            if (data.status === 200) {
                setCategories(data.data.items)
                setCurrentPage(data.data.current_page);
                setTotalPages(data.data.last_page);
                setReFetchData(false); // Add this line
            } else {
                showToast('Oops, Something went wrong', data.message, 'error')
            }
        } catch (error) {
            showToast('Oops, Something went wrong', error.response.data.message || 'There is an error, please try again later', 'error')
        } finally {
            setLoader(false);
        }
    }, [currentPage, debouncedSearch, orderBy, orderDir, user.token]); // Added orderBy and orderDir to dependencies

    useEffect(() => {
        fetchCategories();
    }, [reFetchData, fetchCategories]); // Simplified dependencies if fetchCategories is stable

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(search);
            setCurrentPage(1); // Reset to the first page on search change
        }, DEBOUNCE_DELAY);

        return () => clearTimeout(handler);
    }, [search]);

    useEffect(() => {
        fetchCategories();
    }, [reFetchData, fetchCategories])

    const handleSort = (column, direction) => {
        setOrderBy(column);
        setOrderDir(direction);
    };

    return (
        <div className='min-h-screen p-2 sl:pt-0 sm:p-2 md:p-4 sl:p-6'>
            <CategoryTable
                categories={categories}
                currentPage={currentPage}
                totalPages={totalPages}
                onSearchChange={setSearch}
                onPageChange={setCurrentPage}
                loader={loader}
                setReFetchData={setReFetchData}
                onSort={handleSort}
                currentOrderBy={orderBy}
                currentOrderDir={orderDir}
            />
        </div>
    )
}
export default CategoryPage;
